import { react2angular } from 'react2angular';
import { TrainInfoPanel } from './TrainInfoPanel';

// React-webtip.module is needed for React to render
angular.module('webtip.module')
  .component('trainInfoPanel', react2angular(
    // Wrap the component to inject the filter
    //Note: The wrapper function is necessary because of how 
    // Angular's dependency injection system works with React components when using react2angular
    ({ $filter, ...props }) => {
      // Create functions that use the Angular filters
      const formatTimestampHoursUnix = (timestamp, timezone) => {
        return $filter('formatTimestampHoursUnix')(timestamp, timezone);
      };
      
      const operationMode = (mode) => {
        return $filter('operationMode')(mode);
      };
      
      // Pass the functions to the React component
      return TrainInfoPanel({ 
        ...props, 
        formatTimestampHoursUnix,
        operationMode
      });
    },
    [
      'train',
      'hasProfile',
      "hasClockAndMode",
      'isTrainConnected',
      'topologyUpdatedTime',
      'syncStatus',
      'packagesForDelete',
      'deleteModalOpen',
      'hasPackageActivation',
      'filteredPackages',
      'onOpenDeletePackagesModal',
      'onOpenActivationModal',
      'onExportTopology',
      'showTopologyDownload'
    ],
    ['$filter'] // Inject the $filter service
  ));
